// src/components/AnimateOnScroll.js
import React, { useState, useEffect, useRef } from 'react';

const AnimateOnScroll = ({ children, threshold = 0.1, delay = 0, duration = 500 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false); // Ensure animation runs only once
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        // Trigger if intersecting and hasn't animated yet
        if (entry.isIntersecting && !hasAnimated) {
          setIsVisible(true);
          setHasAnimated(true);
          // Optional: stop observing after animation triggered
          if (ref.current) {
            observer.unobserve(ref.current);
          }
        }
      },
      { threshold } // Use the passed threshold
    );

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    // Cleanup observer on unmount
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [threshold, hasAnimated]); // Depend on threshold and hasAnimated

  const style = {
    transition: `opacity ${duration}ms ease-out ${delay}ms, transform ${duration}ms ease-out ${delay}ms`,
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateY(0)' : 'translateY(20px)', // Slide up effect
  };

  return (
    <div ref={ref} style={style}>
      {children}
    </div>
  );
};

export default AnimateOnScroll;